export default {"src":"/_next/static/media/qm.eda8ed64.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};